import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './SettingsManagement.css';

const tiles = [
  {
    icon: '💰',
    title: 'Payment Settings',
    permissionKey: 'settings.payment_settings',
    description:
      'Configure payment types, methods, invoice generation dates, and transaction charges',
    url: 'payment-settings',
  },
  {
    icon: '📒',
    title: 'Manage Expense Categories',
    permissionKey: 'settings.expense_categories',
    description: 'Add, edit, or delete expense categories; mark staff expenses',
    url: 'expense-categories',
  },
  {
    icon: '📱',
    title: 'WhatsApp Settings',
    permissionKey: 'settings.whatsapp_settings',
    description: 'Configure messaging templates and settings',
    url: 'whatsapp-settings',
  },
];

const SettingsManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RequireMenuAccess>
      <RTPageLayout title="Settings" mainSection activePath={location.pathname}>
        <div className="rt-tiles-grid">
          {tiles.map((tile, idx) => (
            <Tile
              key={idx}
              icon={tile.icon}
              title={tile.title}
              description={tile.description}
              disabled={tile.disabled}
              permissionKey={tile.permissionKey}
              onClick={() => tile.url && navigate(tile.url)}
              tabIndex={0}
              role="button"
              onKeyPress={(e) => {
                if (e.key === 'Enter' && tile.url) navigate(tile.url);
              }}
            />
          ))}
        </div>
      </RTPageLayout>
    </RequireMenuAccess>
  );
};

export default SettingsManagement;
